// VIN-step copy. The other QE2 copy blocks (PHOTO_COPY, VERDICT_COPY,
// SEND_COPY, DAMAGE_ZONE_COPY, RESUME_COPY, SHIP_NOW_COPY) were used
// only by QE2's now-retired components — moved to this file with just
// VIN_COPY since that's the only block StepVehicle actually consumes.

export const VIN_COPY = {
  scanLabel: "Scan VIN",
  typeLabel: "Type VIN instead",
  scanHelpLabel: "Where do I find the VIN?",
  retakeLabel: "Retake photo",
  reading: "Reading VIN…",
  // One message — the user doesn't need to know whether it was OCR,
  // the decode service, or a partial result. Just retake or type.
  scanFailed: "Couldn't read it. Try again or type the VIN.",
  inputPlaceholder: "17-character VIN",
  inputHelp: "Numbers and letters only — no I, O, or Q.",
  editLabel: "Edit",
  rescanLabel: "Rescan",
  // Quietly hint that license-plate scanning is on the roadmap so users
  // don't repeatedly try to point the camera at their plate today.
  plateTip: "Tip: license-plate scanning is coming soon — for now, scan the VIN itself.",
}
